import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  image: {
    width: '75vw',
    height: 'auto',
    marginBottom: theme.spacing(2),
  },
  content: {
    textAlign: 'center',
    padding: 0,
    overflow: 'visible',
  },
  dialogPaper: {
    width: '80vw',
    maxWidth: 'none',
    maxHeight: 'none',
    '@media (max-width:500px)': {
      width: '95vw',
    },
    '@media (max-width:450px)': {
      margin: '0 10px',
    },
  },
  scrollPaper: {
    '@media (max-width:450px)': {
      justifyContent: 'flex-start',
    },
  },
});

function PopupModal(props) {
  const { classes } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Vérifie si la modal a déjà été affichée durant cette visite (session)
    const modalShown = sessionStorage.getItem('popupModalShown');
    //if (!modalShown) {
      setOpen(true);
      sessionStorage.setItem('popupModalShown', 'true');
    //}
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      classes={{ scrollPaper: classes.scrollPaper }}
      PaperProps={{ className: classes.dialogPaper }}
    >
      <DialogContent className={classes.content}>
        <a href="https://www.chiesiconnect.fr/fr.html" target="_blank" rel="noopener">
          <img
            src="/popup_fermeture.jpg"
            alt="Fermeture prochaine du site"
            className={classes.image}
          />
        </a>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(PopupModal); 